import React from 'react';
import { Box, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ReportsMobileCard from '../common/ReportsMobileCard';
import { formatDateAsSent, formatTimeToIST } from '../../../utils/dateUtils';
import { showAmount, showSignedInr, movementColor, entryAmount } from './ledgerAmount';

/**
 * Ledger rows as flat cards, used below the `sm` breakpoint.
 *
 * Everything is visible at once — no expand/collapse — so each card is two
 * blocks: date/time with the amount and closing balance, then the narration
 * with the details affordance.
 *
 * Row 1 wraps onto two lines rather than one: at 360px the card has ~286px of
 * usable width and the four values need ~301px, so a single line would clip.
 */
const LedgerMobileList = ({ ledgerData, onViewDetails }) => (
  <Box
    sx={{
      p: 1,
      willChange: 'scroll-position',
      WebkitOverflowScrolling: 'touch',
      overflow: 'auto',
      flex: 1,
    }}
  >
    {ledgerData.map((entry) => {
      const { magnitude, direction } = entryAmount(entry);

      return (
        <ReportsMobileCard
          key={entry.id}
          lines={[
            {
              left: formatDateAsSent(entry.created_at),
              right: { label: 'Closing Bal', value: showSignedInr(entry.balance) },
            },
            {
              left: formatTimeToIST(entry.created_at),
              right: {
                value: direction === 0 ? '-' : `${direction > 0 ? '+' : '-'}₹${showAmount(magnitude)}`,
                strong: true,
                color: movementColor(direction),
              },
            },
          ]}
          footer={entry.narration}
          footerAction={(
            <IconButton
              size="small"
              aria-label={`View details for ${formatDateAsSent(entry.created_at)} transaction`}
              onClick={() => onViewDetails(entry)}
              sx={{ flexShrink: 0, color: 'primary.main', p: 0.5 }}
            >
              <InfoIcon sx={{ fontSize: '1.25rem' }} />
            </IconButton>
          )}
        />
      );
    })}
  </Box>
);

export default LedgerMobileList;
